/*
 * @Author: katty 15032801667@163.com
 * @Date: 2022-12-01 18:11:16
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-02-22 16:44:30
 * @FilePath: \epec-ea\src\modules\projectA\api\approve\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "../request";
const server = {
  //添加审批流
  addApprove: function(params) {
    return request.post('/purchase/audit/addAudit', params);
  },
  //编辑审批流
  editApprove:  function(params){
    return request.post('/purchase/audit/modify', params);
  },
  //删除审批流
  removeApprove: function(params){
    return request.post('/purchase/audit/remove', params);
  },
    //审批设置查询
    queryApproveSetting: function(){
      return request.post('/user-center/companyConfig/queryOrderConfig')
  
  },
    //审批设置查询
  saveApprovalProcessSwitch: function(params){
      return request.post('/user-center/companyConfig/saveOrderConfig',params)
  },
  //查询审批流数量listWorkflow
  listWorkflow: function(params){
    return request.post('/purchase/audit/page',params)
  },
  //审批流详情
  queryApproveDetail:function(params){
    return request.post('/purchase/audit/detail',params)
  },
    //易应急设置保存
    saveYYJSwitch: function(params){
      return request.post('/user-center/companyConfig/saveYYJSwitch',params)
  },
   //易应急查询
   queryYYJSwitch: function(params){
    return request.post('/user-center/companyConfig/queryYYJSwitch',params)
},
   //查询选商定价开关
  queryOrderAskPrice: function(params){
    return request.post('/user-center/companyConfig/queryOrderAskPrice',params)
},


};

export default server;
